class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
  'transitionend',
  () => {
    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      :  this.querySelector('.drawer__inner');    // ✅ scoped to drawer, never null
    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

    if (containerToTrapFocusOn && focusElement) {
  trapFocus(containerToTrapFocusOn, focusElement);
} else {
  console.warn("[CartDrawer.open] Missing container or focusElement", { containerToTrapFocusOn, focusElement });
}

  },
  { once: true }
);


    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState, { silent = false } = {}) {
   const wrapper = this.querySelector('#CartDrawer');
  if (wrapper) {
    wrapper.classList.remove('is-empty');   // ✅ force remove
  }

  this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
  this.productId = parsedState.id;

  this.getSectionsToRender().forEach((section) => {
  const html = parsedState.sections[section.id];
  console.warn(" HTML for section", html);

  if (!html) {
    console.warn("🔴 Missing HTML for section", section.id, parsedState.sections);
    return;
  }

  const sectionElement = section.selector
    ? document.querySelector(section.selector)
    : document.getElementById(section.id);

  if (!sectionElement) {
    console.warn("🔴 Could not find sectionElement in DOM", section.selector || section.id);
    return;
  }
  if (sectionElement) {
      const newInner = this.getSectionInnerHTML(html, section.selector);
      sectionElement.innerHTML = newInner;
    }

  sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
});

// ✅ Fix: toggle `is-empty` on the <cart-drawer> wrapper itself
  const outerDrawer = document.querySelector('cart-drawer'); 
  if (outerDrawer) {
    const hasItems = parsedState.item_count > 0;
    outerDrawer.classList.toggle('is-empty', !hasItems);
  }


 setTimeout(() => {
  this.querySelector('#CartDrawer-Overlay')
    .addEventListener('click', this.close.bind(this));
  if (!silent) {
    this.open();
  } else {
  }
});
}

 getSectionInnerHTML(html, selector = '.shopify-section') {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const found = parsed.querySelector(selector);
  if (!found) {
    console.warn("🔴 [CartDrawer.getSectionInnerHTML] Selector not found", { selector, htmlSnippet: html.slice(0, 200) });
    return "";
  }
  return found.innerHTML;
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-drawer__footer', // ✅ add footer too
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
